<template>
    <div class="card" :class="'card-' + tipo" @click="$emit('abrir', tipo)">
        <div class="card-thumb">
            <div class="hover-overlay-content">
                <p class="price-discipline">R$ {{ displayPrice }}</p>
            </div>
            <a class="btn-cart-content" @click.stop="addToCart" title="Adicionar ao carrinho">
                <i class="fa fa-cart-plus icon"></i>
            </a>
            <a class="ver-material" @click.stop="$emit('abrir', tipo)">Ver todo o material</a>
        </div>

        <div class="card-footer">
            <h3 class="card-title-content">{{ titulo }}</h3>
        </div>
    </div>
</template>

<script>
import '../styles/Content.css'
import { getFullPackagePriceByType, formatPrice } from '@/utils/pricing';

export default {
    props: {
        titulo: String,
        tipo: String
    },
    computed: {
        rawPrice() {
            return getFullPackagePriceByType(this.tipo);
        },
        displayPrice() {
            return formatPrice(this.rawPrice);
        }
    },
    methods: {
        addToCart(event) {
            event.stopPropagation();
            event.preventDefault();

            const item = {
                codigo_disciplina: this.$route.query.discipline || this.$route.query.codigo,
                nome_disciplina: `Pacote de ${this.titulo}`,
                url_imagem: null,
                preco: this.rawPrice,
                tipo: `pacote-${this.tipo}`,
                isPacote: false
            };

            console.log("CategoryCard - Adicionando ao carrinho:", item);
            this.$emit('add-to-cart', item);
        }
    }
};
</script>
